import React, { lazy } from 'react';
import { AppRoute } from '../routes.types';
import NdaSuccess from '../../containers/UserPages/NdaSuccess/NdaSuccess';
import DocSuccess from '../../containers/UserPages/DocSuccess/DocSuccess';
import Thankyou from '../../components/Thankyou/Thankyou';
import DocDecline from '../../containers/UserPages/DocDecline/DocDecline';
import TermsOfService from '../../containers/UserPages/TermsOfService/TermsOfService';
import PrivacyPolicy from '../../containers/UserPages/PrivacyPolicy/PrivacyPolicy';
import BuyerTermsOfService from '../../containers/UserPages/BuyerTermsOfService/BuyerTermsOfService';
import DocumentSignedFrame from '../../containers/UserPages/DocumentSignedFrame/DocumentSignedFrame';
import { DataRequestDashboardPage } from '../../containers/DataRequest/DataRequestDashboardPage/DataRequestDashboardPage';

const Login = lazy(() => import('../../containers/UserPages/Login/index'));
const ForgotPwd = lazy(() => import('../../containers/UserPages/ForgotPassword/index'));
const Register = lazy(() => import('../../containers/UserPages/Register'));
const Landing = lazy(() => import('../../containers/Landing/Landing'));
const FEPage = lazy(() => import('../../containers/FreeAndEasy/FEPage'));

export const PUBLIC_ROUTES: AppRoute[] = [
    { path: '/', element: <Login /> },
    { path: '/login', element: <Login /> },
    { path: '/forgotpwd', element: <ForgotPwd /> },
    { path: '/register', element: <Register /> },
    { path: '/landing', element: <Landing /> },
    { path: '/F&E', element: <FEPage /> },
    { path: '/terms-of-service', element: <TermsOfService /> },
    { path: '/privacy-policy', element: <PrivacyPolicy /> },
    { path: '/buyer-terms-of-service', element: <BuyerTermsOfService /> },
    { path: '/nda-success', element: <NdaSuccess /> },
    { path: '/doc-success', element: <DocSuccess type="agreement" /> },
    { path: '/doc-nda-success', element: <DocSuccess type="nda" /> },
    { path: '/doc-declined', element: <DocDecline /> },
    { path: '/doc-signed-frame', element: <DocumentSignedFrame /> },
    { path: '/thank-you', element: <Thankyou /> },
    { path: '/data-request-dashboard', element: <DataRequestDashboardPage /> },
    { path: '/data-request-dashboard/others', element: <DataRequestDashboardPage /> },
];
